import { createAction, props } from "@ngrx/store";
import {
  RoomMixerErrorEventVO,
  RoomMixerStartedEventVO,
  RoomMixerStartEventVO,
  RoomMixerToRotateEventVO
} from "@youm-front/room/domain";

/**
 * @deprecated
 * @todo Migrate to RoomLiveStreamStatusEvents.
 */
export const roomMixerErrorEvent = createAction(
  "[Room Mixer] Room Mixer Error Event",
  props<{ roomMixerErrorEventVO: RoomMixerErrorEventVO }>()
);

/**
 * @deprecated
 * @todo Migrate to RoomLiveStreamStatusEvents.
 */
export const roomMixerToRotateEvent = createAction(
  "[Room Mixer] Room Mixer To Rotate Event",
  props<{ roomMixerToRotateEventVO: RoomMixerToRotateEventVO }>()
);

/**
 * @deprecated
 * @todo Migrate to RoomLiveStreamStatusEvents.
 */
export const roomMixerStartEvent = createAction(
  "[Room Mixer] Room Mixer Start Event",
  props<{ roomMixerStartEventVO: RoomMixerStartEventVO }>()
);

/**
 * @deprecated
 * @todo Migrate to RoomLiveStreamStatusEvents.
 */
export const roomMixerStartedEvent = createAction(
  "[Room Mixer] Room Mixer Started Event",
  props<{ roomMixerStartedEventVO: RoomMixerStartedEventVO }>()
);
